export const SIGNUP_ATTRIBUTION_COOKIE = "signup_attribution"

export const SIGNUP_ATTRIBUTION_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

export const ATTRIBUTION_VALUE_PATTERN = /^[a-z0-9_-]{1,64}$/

export const LANDING_PATH_PATTERN = /^\/[A-Za-z0-9/_.-]{0,255}$/
